import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { AssessmentReportFillTemplate } from "app/features/reporting/templates/AssessmentReportFillTemplate";

export function AddMustReport() {
  const { resident } = useResidentContext();

  const backPath = resident?.id ? `/residents/${resident.id}/must` : undefined;

  return (
    <AssessmentReportFillTemplate tag={FormEnums.MUST} backPath={backPath} />
  );
}
